// extracted by mini-css-extract-plugin
module.exports = {"row":"_7a3fb80146--row--nJk8j","key":"_7a3fb80146--key--lI4q6","value":"_7a3fb80146--value--YrvYr","warning":"_7a3fb80146--warning--qDc3L"};